;(function (win, lib) {
    var doc = win.document
    var docEl = doc.documentElement
    var metaEl = doc.querySelector('meta[name="viewport"]')
    var flexibleEl = doc.querySelector('meta[name="flexible"]')
    var dpr = 0
    var scale = 0
    var tid
    var flexible = lib.flexible || (lib.flexible = {})

    if (metaEl) {
        console.warn('将根据已有的meta标签来设置缩放比例')
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/)
        if (match) {
            scale = parseFloat(match[1])
            dpr = parseInt(1 / scale)
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content')
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/)
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/)
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1])
                scale = parseFloat((1 / dpr).toFixed(2))
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1])
                scale = parseFloat((1 / dpr).toFixed(2))
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi)
        var isIPhone = win.navigator.appVersion.match(/iphone/gi)
        var devicePixelRatio = win.devicePixelRatio
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
                dpr = 2
            } else {
                dpr = 1
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1
        }
        scale = 1 / dpr
    }

    docEl.setAttribute('data-dpr', dpr)
    if (!metaEl) {
        metaEl = doc.createElement('meta')
        metaEl.setAttribute('name', 'viewport')
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no')
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl)
        } else {
            var wrap = doc.createElement('div')
            wrap.appendChild(metaEl)
            doc.write(wrap.innerHTML)
        }
    }

    // function refreshRem(){
    //     var width = docEl.getBoundingClientRect().width;
    //     if (width / dpr > 540) {
    //         width = 540 * dpr;
    //     }
    //     var rem = width / 10;
    //     docEl.style.fontSize = rem + 'px';
    //     flexible.rem = win.rem = rem;
    // }

    function expectedRem() {
        var width = win.innerWidth || docEl.clientWidth // 避免桌面滚动条占用移动版心宽度
        if (!width) return 0
        if (width > 430) width = 430
        return width / 10
    }

    function applyRootFontSize(rem) {
        docEl.style.fontSize = rem + 'px'
        // 系统字号或微信字号会把根字号再放大，导致 rem 布局超出屏幕。按实际计算值反向抵消。
        var actual = parseFloat(win.getComputedStyle(docEl).fontSize)
        if (actual && Math.abs(actual - rem) > 0.5) {
            docEl.style.fontSize = (rem * rem) / actual + 'px'
        }
        flexible.rem = win.rem = rem
    }

    function refreshRem() {
        var rem = expectedRem()
        if (!rem) return
        applyRootFontSize(rem)
    }

    function settleRootFontSize() {
        refreshRem()
        if (!win.requestAnimationFrame) return
        win.requestAnimationFrame(function () {
            var rem = expectedRem()
            var actual = parseFloat(win.getComputedStyle(docEl).fontSize)
            if (rem && actual && Math.abs(actual - rem) > 0.5) applyRootFontSize(rem)
        })
    }

    function lockTextSizeAdjust() {
        docEl.style.setProperty('-webkit-text-size-adjust', '100%', 'important')
        docEl.style.setProperty('text-size-adjust', '100%', 'important')
        if (!doc.body) return
        doc.body.style.setProperty('-webkit-text-size-adjust', '100%', 'important')
        doc.body.style.setProperty('text-size-adjust', '100%', 'important')
    }

    function lockWechatFontSize() {
        function handle() {
            if (!win.WeixinJSBridge || typeof win.WeixinJSBridge.invoke !== 'function') return
            lockTextSizeAdjust()
            win.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
            if (!flexible.wechatFontLocked) {
                flexible.wechatFontLocked = true
                win.WeixinJSBridge.on('menu:setfont', function () {
                    win.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
                    lockTextSizeAdjust()
                    settleRootFontSize()
                })
            }
            settleRootFontSize()
        }

        if (typeof win.WeixinJSBridge === 'object' && typeof win.WeixinJSBridge.invoke === 'function') {
            handle()
        } else {
            doc.addEventListener('WeixinJSBridgeReady', handle, false)
        }
    }

    win.addEventListener(
        'resize',
        function () {
            clearTimeout(tid)
            tid = setTimeout(settleRootFontSize, 300)
        },
        false
    )
    win.addEventListener(
        'pageshow',
        function () {
            clearTimeout(tid)
            tid = setTimeout(settleRootFontSize, 0)
        },
        false
    )
    win.addEventListener('load', settleRootFontSize, false)

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px'
        lockTextSizeAdjust()
    } else {
        doc.addEventListener(
            'DOMContentLoaded',
            function () {
                doc.body.style.fontSize = 12 * dpr + 'px'
                lockTextSizeAdjust()
            },
            false
        )
    }

    lockTextSizeAdjust()
    settleRootFontSize()
    lockWechatFontSize()

    flexible.dpr = win.dpr = dpr
    flexible.refreshRem = refreshRem
    flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px'
        }
        return val
    }
    flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem'
        }
        return val
    }
})(window, window['lib'] || (window['lib'] = {}))
